/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from "react";

import { useLogger } from "util/logger";

import {
  useStripe,
  useElements,
  CardNumberElement,
} from "@stripe/react-stripe-js";
import { useQueryClient } from "@tanstack/react-query";
import {
  PatientModelDTO,
  usePatchPatient,
  usePostPatientPaymentMethod,
  usePostShippingAddressesHook,
} from "api-client";
import { getGetMeQueryKey } from "apiClients/apiPatient";
import { useLocalStorage } from "hooks/useLocalStorage";
import { useMeHook } from "hooks/useMe";
import { useNavigates } from "hooks/useNavigates";
import { useSessionStorage } from "hooks/useSessionStorage";
import { Id, toast } from "react-toastify";
//import { useRecoilValue } from "recoil";
//import { me } from "selectors/user";

import { Presenter } from "./Presenter";

type Props = {
  clientSecret: string;
};

export const CheckoutForm: React.FC<Props> = (props) => {
  const logger = useLogger();
  const { clientSecret } = props;
  const [value] = useLocalStorage("patientId");
  const [userData] = useSessionStorage("user");
  const { navigateSignUpFinish } = useNavigates();
  const queryClient = useQueryClient();
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [patient, setPaient] = useState<PatientModelDTO>();
  //const patient = useRecoilValue(me);
  const [patientId] = useLocalStorage("patientId");
  const stripe = useStripe();
  const elements = useElements();
  const usePostShippingAddresses = usePostShippingAddressesHook();
  const getPatientHook = useMeHook();

  /*const refreshUserInfo = useRecoilCallback(
    ({ set }) =>
      async () => {
        const patient = useMeHook();
        const me = patient();
        set(userState, await me);
      },
    [me]
  );*/
  const getPatient = async () => {
    const me = getPatientHook();
    const response = await me;

    setPaient({
      ...response.patient,
      additionalDocuments: response.additionalDocuments as any,
      insuranceCardUpdatedAt: response.insuranceCard?.updatedAt ?? "",
      paymentMethods: response.paymentMethods as any,
    } as unknown as PatientModelDTO);
  };

  useEffect(() => {
    getPatient();
    // eslint-disable-next-line
  }, []);

  const postPatientPaymentMethod = usePostPatientPaymentMethod({
    mutation: {
      onSuccess() {
        queryClient.invalidateQueries({ queryKey: getGetMeQueryKey() });
        navigateSignUpFinish();
      },
      onError(e) {
        const toastId = toast.error(`${e.message}`);
        setTimeout(() => {
          toast.dismiss(toastId);
        }, 2000);
        setDisabled(true);
        setLoading(false);
      },
    },
  });
  const patchPatient = usePatchPatient({
    mutation: {
      onSuccess(_) {
        let toastId: Id = "";
        if (patient?.paymentMethods?.length === 0) {
          toastId = toast.success("カードの登録が完了しました");
        } else {
          toastId = toast.success("カードの更新が完了しました");
        }
        setTimeout(() => {
          toast.dismiss(toastId);
        }, 2000);
      },
      onError(e) {
        toast.error(`${e}`);
      },
    },
  });

  const handleSubmit = async (event: any) => {
    if (!stripe || !elements) return;
    setDisabled(true);
    setLoading(true);

    event.preventDefault();
    const cardNumberElement = elements.getElement(CardNumberElement);

    if (!cardNumberElement) return;

    try {
      const { error, setupIntent } = await stripe.confirmCardSetup(
        clientSecret,
        {
          payment_method: {
            card: cardNumberElement,
            billing_details: {},
          },
        }
      );
      if (error) {
        logger({
          log: "カード設定エラー",
          errorType: "media",
          errorCode: error.code,
          errorMessage: error.message,
        });

        const toastId = toast.error(`${error.message}`);

        setTimeout(() => {
          toast.dismiss(toastId);
          setDisabled(false);
          setLoading(false);
        }, 2000);
        return;
      }

      // 入力された住所をお薬のお届け先住所のデフォルトとして登録する
      const today = new Date();
      const usePostShippingAddressesResult = await usePostShippingAddresses({
        // eslint-disable-line react-hooks/rules-of-hooks
        patientId: patientId!,
        prefecture: patient!.prefecture,
        postalCode: patient!.postalCode,
        address: patient!.address,
        createdAt: today.getTime(),
        updatedAt: today.getTime(),
        createdBy: patientId!,
        updatedBy: patientId!,
        isDeleted: 0,
      });

      // 初回登録完了フラグをtrueにする
      await patchPatient.mutateAsync({
        id: patientId!,
        data: {
          name: patient!.name,
          nameKana: patient!.nameKana,
          email: patient!.email,
          postalCode: patient!.postalCode,
          prefecture: patient!.prefecture,
          address: patient!.address,
          gender: patient!.gender,
          birthDay: patient!.birthDay || "",
          phoneNumber: patient!.phoneNumber,
          finishedInitRegister: true,
          shippingAddressId: usePostShippingAddressesResult.id,
        },
      });
      // ユーザ情報更新
      //await refreshUserInfo();
      localStorage.setItem("finishedInitRegister", "true");

      if (setupIntent) {
        postPatientPaymentMethod.mutate({
          data: {
            id: `${value}`,
            name: userData?.name || "",
            email: userData?.email || "",
            paymentMethod: `${setupIntent.payment_method}`,
          },
        });
      }
    } catch (e: unknown) {
      logger({
        log: "カード設定中の予期せぬエラー",
        errorType: "media",
        errorMessage: e instanceof Error ? e.message : "不明なエラー",
      });
    }
    setDisabled(false);
    setLoading(false);
  };

  return (
    <Presenter
      handleSubmit={handleSubmit}
      stripe={stripe}
      disabled={disabled}
      loading={loading}
    />
  );
};
